module.exports = __webpack_public_path__ + "images/b9d9a8bc9392462ca70a214ab740d1d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/wheels-characters01.jpg
// module id = ./webpack/assets/img/wheels-characters01.jpg
// module chunks = 0